import { loadRules, type Rules } from "odyssey-shared";

/**
 * The page's rules (ADR-069 decisions 6 and 8): the tables this build carries, read once through the rules
 * loader as the game module is read, and what the page makes of a `welcome` whose map server runs other tables.
 */

/**
 * The rules this page was built with. A page draws by them (names, costs, cooldowns) and decides nothing by them.
 */
export const PAGE_RULES: Rules = loadRules();

/**
 * Why a welcome's rules are not the page's, for the loading shell's detail line.
 *
 * @param welcomed The version `welcome` names, the rules the player's map server runs.
 * @param loaded The version of the page's own rules.
 * @returns Null when they are one version; otherwise the detail naming both.
 * @example
 * rulesMismatch("r-0123abcd", "r-89abcdef");
 * // "rules r-0123abcd differ from loaded r-89abcdef"
 */
export function rulesMismatch(welcomed: string, loaded: string): string | null {
  return welcomed === loaded ? null : `rules ${welcomed} differ from loaded ${loaded}`;
}
